module.exports = __webpack_public_path__ + "static/media/nana-sad.d69ae954.png";